import VtLoadingButtonSpinner from '@/components/common/vt-loading-button/vt-loading-button-spinner/vt-loading-button-spinner.vue'
import { initialVTLoadingButtonState, VtLoadingButtonParams, VTLoadingButtonState } from '@/components/common/vt-loading-button/vt-loading-button.model'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { Nullable } from '@/shared/types/app.types'
import { BButton } from 'bootstrap-vue/src/components/button'

@Component({
    components: {
        VtLoadingButtonSpinner
    }
})
export default class VtLoadingButton extends Vue {
    @Ref() readonly vtLoadingButton!: BButton
    @Prop() readonly params!: VtLoadingButtonParams

    state!: VTLoadingButtonState

    constructor() {
        super()
        this.state = initialVTLoadingButtonState()
    }

    get shortkeysButton(): Nullable<string[]> {
        return this.params?.shortkeys
    }

    get isDisabled(): boolean {
        return !!this.$attrs.disabled || this.state.loading
    }

    get isIcon(): boolean {
        if ((this.$slots?.default as any)?.length > 1) {
            return false
        }
        return (this.$slots?.default?.[0] as any).tag === 'i'
    }

    async onClick(): Promise<void> {
        if (typeof this.params.promise === 'function' && !this.isDisabled) {
            this.state.loading = true
            try {
                await this.params.promise()
            } catch {

            } finally {
                this.state.loading = false
            }
        }
    }

    public focus():void {
        this.vtLoadingButton.focus()
    }
}
